const editPrivacyPolicyConstantsAr = {
  privacyPolicyPageTitle: 'سياسة الخصوصية و سياسة ملفات تعريف الإرتباط',
  privacyPolicyBreadcrumb: 'سياسة الخصوصية و سياسة ملفات تعريف الإرتباط',
};

export default editPrivacyPolicyConstantsAr;
